import { action, makeObservable, observable, reaction } from 'mobx';

class CheckoutMaterialRepository {
  materialPm = {
    format: null,
    duration: null,
    productType: null,
    subject: null,
    class: null,
    price: null,
    title: null,
    image: null,
    author: null,
    variantId: null,
  };

  constructor() {
    makeObservable(this, {
      materialPm: observable,
      updateMaterial: action,
    });
  }

  load(callback) {
    reaction(
      () => [this.materialPm],
      () => callback(this.materialPm),
      { fireImmediately: true }
    );
  }

  updateMaterial = (newModel) => {
    this.materialPm.format = newModel.format;
    this.materialPm.duration = newModel.duration;
    this.materialPm.productType = newModel.productType;
    this.materialPm.subject = newModel.subject;
    this.materialPm.class = newModel.class;
    this.materialPm.price = newModel.price;
    this.materialPm.title = newModel.title;
    this.materialPm.image = newModel.image;
    this.materialPm.author = newModel.author;
    this.materialPm.variantId = newModel.variantId;
  };
}

const checkoutMaterialRepository = new CheckoutMaterialRepository();

export default checkoutMaterialRepository;
